/**
 * DeclinationDisplay
 *
 * Small overlay showing the magnetic declination for the current map position.
 * Displays the declination value, a CSS-rotated compass arrow, and the
 * reference year.
 */

import React, { useMemo } from 'react'
import { getMagneticDeclination } from '../utils/printMap.js'

/**
 * @param {{ lat: number|null, lng: number|null }} props
 */
export function DeclinationDisplay({ lat, lng }) {
  const declination = useMemo(() => {
    if (lat == null || lng == null) return null
    return getMagneticDeclination(lat, lng)
  }, [lat, lng])

  if (!declination) {
    return (
      <div className="declination-display" aria-label="Magnetic Declination">
        <span className="declination-value">MagN ---</span>
      </div>
    )
  }

  // Rotate the arrow by the declination amount (east = clockwise)
  const rotation = declination.direction === 'E'
    ? declination.declination
    : -declination.declination

  return (
    <div className="declination-display" aria-label="Magnetic Declination">
      <div className="declination-compass">
        <span
          className="declination-arrow"
          style={{ transform: `rotate(${rotation}deg)` }}
          aria-hidden="true"
        >
          &#9650;
        </span>
      </div>
      <div className="declination-info">
        <span className="declination-value">
          MagN {declination.declination.toFixed(1)}&deg; {declination.direction}
        </span>
        <span className="declination-year">({declination.year})</span>
      </div>
    </div>
  )
}

export default DeclinationDisplay
